enum AuditStatus {
   DRAFT = 1,
   SENT = 2,
   IN_PROGRESS = 3,
   FOR_REVIEW = 4,
   COMPLETED = 5,
}

enum AuditFilterStatus {
   WORKING = '0',
   DRAFT = '1',
   SENT_IN_PROGRESS = '2',
   FOR_REVIEW = '4',
   COMPLETED = '5',
}

enum AddAuditView {
   Default = 1,
   ItemSelector = 2,
}

export { AuditStatus, AuditFilterStatus, AddAuditView }
